export default {
  assetDocumentation: 'Dokumentácia zariadenia',
  noAssetBlobs: 'Zariadenie {asset} nemá žiadnu dokumentáciu.',
  overheadTime: 'Réžijný čas',
  engineerNote: 'Priradená osoba',
  managerFeedback: 'Manažér',
  deleteLastEventMessage: 'Chystáte sa odstrániť poslednú udalosť série.\nTým sa odstráni celá séria.\n{text}',
  inProgressStateWarning: 'Prosím označte úlohy ako dokončené alebo preskočené. Ak je niektorá úloha preskočená, zanechajte komentár ku každej preskočenej úlohe.',
  inReviewStateWarning: 'Aby bolo možné označiť udalosť ako "Dokončenú", všetky úlohy musia byť označené ako "Akceptované"',
};
